import AWS from 'aws-sdk';
import axios from 'axios';


let awsAccessKey;
let awsSecretKey;
let awsRegion;
let baseURL;


if (process.env.REACT_APP_ENV === "development") {
  awsAccessKey = process.env.REACT_APP_AWS_ACCESS_KEY;
  awsSecretKey = process.env.REACT_APP_AWS_SECRET_KEY;
  awsRegion = process.env.REACT_APP_AWS_REGION;
  baseURL = process.env.REACT_APP_API_BASE_URL;
}

else if (process.env.REACT_APP_ENV === "production"){
  awsAccessKey = process.env.REACT_APP_AWS_ACCESS_KEY;
  awsSecretKey = process.env.REACT_APP_AWS_SECRET_KEY;
  awsRegion = process.env.REACT_APP_AWS_REGION;
  baseURL = process.env.REACT_APP_API_BASE_URL;
}


// Configure AWS with your credentials
AWS.config.update({
  accessKeyId: awsAccessKey,
  secretAccessKey: awsSecretKey,
  region: awsRegion // e.g., "us-east-1"
});

const s3 = new AWS.S3();

export const uploadOriginalToS3 = async (file, fileName, bucketName, customMetaData, onProgress) => {

  const params = {
    Bucket: bucketName,
    Key: `uploads/${file.name}`, 
    Body: file,
    ContentType: file.type,
    Metadata: customMetaData,
    // ACL: "public-read"
  };

  const uploadOptions = {
    partSize: 8 * 1024 * 1024,
    queueSize: 6
  };

  const upload = s3.upload(params, uploadOptions);

  if (onProgress) {
    upload.on('httpUploadProgress', onProgress);
  }

  return upload.promise();
};


export const fetchGalleryList = async (eventId, userId, page = 1, limit = 10) => {
  const url = `${baseURL}/gallery/photos?event_id=${eventId}&user_id=${userId}&page=${page}&limit=${limit}`;
  try {
    const response = await axios.get(url, {
      headers: { "x-api-key": process.env.REACT_APP_BROWSER_API_KEY },
    });
    const photos = response.data?.photos || [];
    return { photos, hasMore: photos.length === limit };
  } catch (error) {
    return { photos: [], hasMore: false };
  }
};

export const fetchSelectedGalleryList = async (eventId, userId, page = 1, limit = 10) => {
  const url = `${baseURL}/gallery/photos?event_id=${eventId}&user_id=${userId}&selected_for_album=true&page=${page}&limit=${limit}`;
  try {
    const response = await axios.get(url, {
      headers: { "x-api-key": process.env.REACT_APP_BROWSER_API_KEY },
    });
    const photos = response.data?.photos || [];
    return { photos, hasMore: photos.length === limit };
  } catch (error) {
    return { photos: [], hasMore: false };
  }
};

export const fetchGalleryListByFolderID = async (eventId, userId, folderId, page = 1, limit = 10) => {
  const url = `${baseURL}/gallery/photos?event_id=${eventId}&folder_id=${folderId}&user_id=${userId}&page=${page}&limit=${limit}`;
  try {
    const response = await axios.get(url, {
      headers: { "x-api-key": process.env.REACT_APP_BROWSER_API_KEY },
    });
    const photos = response.data?.photos || [];
    return { photos, hasMore: photos.length === limit };
  } catch (error) {
    return { photos: [], hasMore: false };
  }
};

